import { render, staticRenderFns } from "./foot_menu.vue?vue&type=template&id=5d4d5aef&scoped=true&"
import script from "./foot_menu.vue?vue&type=script&lang=js&"
export * from "./foot_menu.vue?vue&type=script&lang=js&"
import style0 from "./foot_menu.vue?vue&type=style&index=0&id=5d4d5aef&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d4d5aef",
  null
  
)

export default component.exports